const Testimonial = () => {
  return (
    <section id='auditPro'>
      <div className='max-w-6xl px-5 mx-auto mt-32 text-center mb-14'>
        <h2 className='text-4xl text-textGray text-center'>
          Apresentamos o AuditPro
        </h2>
        <p className='mt-2 text-darkGrayishBlue'>
          A Hotline desenvolveu o AuditPro para ajudar empresas a navegarem com segurança pela nova era tributária.
          Com nossa solução, você substitui horas de pesquisas manuais em planilhas e portais governamentais por uma ferramenta rápida, intuitiva e totalmente confiável, projetada para garantir a correta classificação tributária de qualquer mercadoria.
        </p>
        <p className='mt-4 text-darkGrayishBlue'>
          Para bens basta inserir o GTIN, cClassTrib, Descrição, CST ou o NCM (Nomenclatura Comum do Mercosul), para serviços  basta inserir o NBS, cClassTrib ou Descrição.
          Obtenha, em segundos, as informações mais recentes e validadas segundo a legislação vigente.
        </p>
      </div>
    </section>
  );
};

export default Testimonial;
